import { toastr } from 'react-redux-toastr';
import { TranslateFunction } from 'react-localize-redux';

export const showTooManySelectedOptionsError = (
  translate: TranslateFunction,
) =>
  toastr.error(`${ translate('update-selection-failed-title') }`,
    `${ translate('update-selection-failed-message') }`);
